<template>
  <div class="floor-r-item" :style="index % 5=== 4?'margin-right:0':''">
    <img class="m-img" :src="product.imgSrc" />
    <p class="m-desc">{{product.Name_view}}</p>
    <div class="price-item">
      <!-- <span style="color: #F56C6C;font-size:16px;font-weight: bold;">￥{{product.Medicine.RetailPrice}}</span> -->
      <span style="fonts-size:12px;color:#909399;">库存{{product.Medicine.StockQuantity}}盒</span>
    </div>
    <p class="m-tag">
      <span style="color: #0084C4;" v-if="product.Medicine.HealthInsurance">{{ product.Medicine.HealthInsurance==0?"医保：否":(product.Medicine.HealthInsurance==1?"医保：甲":"医保：乙") }}</span>
      <span style="background-color:#F0F9EB;color: #67C23A;" v-if="product.Medicine.BaseMedicine">基药</span>
      <!-- <span style="background-color:#F0F9EB;color: #67C23A;" v-if="product.Medicine.Nonghe">农合</span> -->
    </p>
  </div>
</template>
<script>
  export default {
    props: [
      'product','index'
    ]
  }
</script>
<style scoped lang="scss">
.floor-r-item{
    width: 215px;
    height: 350px;
    display: inline-block;
    margin-right: 25px;;
    margin-bottom: 20px;
    vertical-align: middle;
    .m-img{
      width: 215px;
      height: 230px;
      /* margin: 0 20px 20px 20px; */
      margin: 0 0 20px 0;
      border-radius: 4px;
      /* border: dashed 1px #ccc; */
    }
    .m-desc{
      padding-top: 11px;
      width: 172px;
      font-size: 14px;
      font-weight: 400;
      line-height: 19px;
      color: #606266;
    }
    .price-item{
      padding: 6px 0;
      display: flex;
      justify-content: space-between;
    }
}
.m-img{
    width: 230px;
    height: 230px;
    margin: 0 0 20px 0;
    /* margin: 0 20px 20px 20px; */
    /* border: dashed 1px #ccc; */
}
.m-tag{
    span{
      display: inline-block;
      padding: 3px 6px;
      line-height: 16px;
      background-color: #EBF4F9;
      border-radius: 22px;
      font-size: 12px;
      margin-right: 8px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/product.vue